import * as React from 'react';

export const LazyProductNOK = React.lazy(() => import('./component'));
